export default __webpack_public_path__ + "static/media/barcode.da447816.png";